module.exports = __webpack_public_path__ + "img/zdfy.67fe3d2b.png";